import { z } from "zod/v4";
export const BIRTH_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Normalizes birth date input by:
 * - converting null/undefined to undefined
 * - trimming strings
 * - treating "", "NULL" (case-insensitive) as undefined
 */
function normalizeBirthDateInputToOptionalString(input) {
    if (input === null || input === undefined)
        return undefined;
    if (typeof input === "string") {
        const trimmed = input.trim();
        if (!trimmed || trimmed.toLowerCase() === "null")
            return undefined;
        return trimmed;
    }
    return input;
}
/**
 * Validates that a string value matches yyyy-mm-dd format
 */
const BirthDateStringValidationSchema = z
    .string()
    .regex(BIRTH_DATE_REGEX, "Må være på formatet yyyy-mm-dd. ");
/**
 * Optional birth date:
 * - normalizes input
 * - only validates format if value is present
 */
export const OptionalBirthDateSchema = z.preprocess(normalizeBirthDateInputToOptionalString, BirthDateStringValidationSchema.optional());
/**
 * Required birth date:
 * - normalizes input
 * - requires a value
 * - validates format
 */
export const RequiredBirthDateSchema = z.preprocess(normalizeBirthDateInputToOptionalString, z
    .string({
    error: (issue) => issue.input === undefined
        ? "Fødselsdato er påkrevd."
        : "Ugyldig fødselsdato.",
})
    .pipe(BirthDateStringValidationSchema));
